import React from 'react';
export default {
  React: React
};